var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.983%",
    cy: "0%",
    fx: "42.983%",
    fy: "0%",
    r: "103.088%",
    gradientTransform: "matrix(.24291 .97005 -.97868 .24507 .325 -.417)",
    id: "e1evrhlaga"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D262",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A650",
    offset: "22.135%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14E2C",
    offset: "50.167%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98069F",
    offset: "82.431%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E18D1",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.003 98.868a6.143 6.143 0 0 0-6.152 6.153 6.143 6.143 0 0 0 6.152 6.153 6.143 6.143 0 0 0 6.152-6.153 6.143 6.143 0 0 0-6.152-6.153zm0 10.154c-2.2 0-4-1.795-4-4 0-2.207 1.794-4.001 4-4.001s4 1.794 4 4-1.8 4-4 4zm7.838-10.406c0 .798-.642 1.435-1.435 1.435a1.435 1.435 0 1 1 1.435-1.435zm4.075 1.457c-.091-1.923-.53-3.626-1.939-5.029-1.402-1.403-3.105-1.842-5.027-1.939-1.981-.112-7.919-.112-9.9 0-1.917.091-3.62.53-5.027 1.934-1.409 1.403-1.842 3.106-1.939 5.028-.112 1.982-.112 7.92 0 9.902.091 1.923.53 3.626 1.939 5.03 1.408 1.402 3.105 1.841 5.027 1.938 1.981.112 7.919.112 9.9 0 1.922-.091 3.625-.53 5.027-1.939 1.403-1.403 1.842-3.106 1.939-5.029.112-1.981.112-7.915 0-9.896zm-2.56 12.022a4.05 4.05 0 0 1-2.28 2.282c-1.58.626-5.328.482-7.073.482-1.746 0-5.499.14-7.073-.482a4.05 4.05 0 0 1-2.281-2.282c-.626-1.58-.482-5.328-.482-7.074 0-1.746-.14-5.5.482-7.074a4.05 4.05 0 0 1 2.28-2.282c1.58-.626 5.328-.482 7.074-.482 1.745 0 5.498-.139 7.073.482a4.05 4.05 0 0 1 2.28 2.282c.627 1.58.482 5.328.482 7.074 0 1.746.145 5.5-.482 7.074z",
    transform: "translate(-21 -93.021)",
    fill: "url(#e1evrhlaga)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6828d328ba4cc856d3c00a4f24062d6f.svg";
export { ForwardRef as ReactComponent };